export enum ChatSenderType {
    SYSTEM = 0,
    PARTNER = 1,
    WORKER = 2,
}